(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header');
            this.templateName = this.getAttribute('data-template-name');
            this.setHeaderHeight();

            window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
        }

        setHeaderHeight() {
            document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        }

        hide() {
            // if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden');
            this.closeMenuDisclosure();
            this.closeSearchModal();
        }

        reveal() {
            // if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }

        reset() {
            // if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'animate');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
            this.disclosures.forEach((disclosure) => disclosure.close());
        }

        closeSearchModal() {
            this.searchModal = this.searchModal || this.header.querySelector('details-modal');
            this.searchModal.close(false);
        }
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-image-slider"] && !Shopify.designMode) return;
  try {
    
    class ProductImageSlider extends HTMLElement {
        constructor() {
            super();
            this.currentIndex = 0;
            this.slides = this.querySelectorAll('.slide');
            this.nextButton = this.querySelector('button.next-button');
            this.prevButton = this.querySelector('button.prev-button');

            this.nextButton.addEventListener('click', () => this.slide(true));
            this.prevButton.addEventListener('click', () => this.slide(false));
        }

        slide(next = false) {
            this.slides[this.currentIndex].classList.remove('--current');
            const mod = next ? 1 : -1;
            this.currentIndex =
                this.currentIndex == 0 && mod < 0
                    ? this.slides.length - 1
                    : (this.currentIndex + mod) % this.slides.length;

            this.slides[this.currentIndex].classList.add('--current');
        }
    }
    customElements.define('product-image-slider', ProductImageSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
    class ImageSlideShow extends HTMLElement {
        constructor() {
            super();

            this.slide = 1;
            this.totalSlides = parseInt(this.getAttribute('data-count'));
            this.nextButton = this.querySelector('button:last-child');
            this.prevButton = this.querySelector('button:first-child');

            this.nextButton.addEventListener('click', this.onNext.bind(this));
            this.prevButton.addEventListener('click', this.onPrev.bind(this));
        }

        connectedCallback() {
            this.onScrollHandler = this.onScroll.bind(this);
            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onScrollHandler, false);
            this.onScroll();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
            window.removeEventListener('resize', this.onScrollHandler);
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const maxScroll = this.offsetHeight;

            const factor = Math.min(scrollTop / maxScroll, 1);
            this.querySelector('li.image-slide__show').style.transform = `scale(${1 * (1 + factor * 0.1)})`;
        }

        onNext(event) {
            const currentSlide = this.querySelector(`#image-slideshow-${this.slide}`);
            const currentSlideText = this.querySelector(`#image-slide__text-${this.slide}`);
            this.slide = this.slide === this.totalSlides ? 1 : this.slide + 1;
            const nextSlide = this.querySelector(`#image-slideshow-${this.slide}`);
            const nextSlideText = this.querySelector(`#image-slide__text-${this.slide}`);

            currentSlide.classList.remove('image-slide__show');
            nextSlide.classList.add('image-slide__show');

            currentSlide.setAttribute('aria-hidden', 'true');
            nextSlide.setAttribute('aria-hidden', 'false');

            currentSlideText.classList.remove('image-slide__text-show');
            nextSlideText.classList.add('image-slide__text-show');

            currentSlideText.setAttribute('aria-hidden', 'true');
            nextSlideText.setAttribute('aria-hidden', 'false');

            this.onScroll();
        }

        onPrev(event) {
            const currentSlide = this.querySelector(`#image-slideshow-${this.slide}`);
            const currentSlideText = this.querySelector(`#image-slide__text-${this.slide}`);
            this.slide = this.slide === 1 ? this.totalSlides : this.slide - 1;
            const nextSlide = this.querySelector(`#image-slideshow-${this.slide}`);
            const nextSlideText = this.querySelector(`#image-slide__text-${this.slide}`);

            currentSlide.classList.remove('image-slide__show');
            nextSlide.classList.add('image-slide__show');

            currentSlide.setAttribute('aria-hidden', 'true');
            nextSlide.setAttribute('aria-hidden', 'false');

            currentSlideText.classList.remove('image-slide__text-show');
            nextSlideText.classList.add('image-slide__text-show');

            currentSlideText.setAttribute('aria-hidden', 'true');
            nextSlideText.setAttribute('aria-hidden', 'false');
        }
    }

    customElements.define('image-slideshow', ImageSlideShow);

  } catch(e) { console.error(e); }
})();
})();
